import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    critical;
    major;
    minor;
    disabled;
    isTotalArea;
    virtualLevelConfigType;
    repNumber = /^(0|\+?[1-9][0-9]{0,7})$/;
    thresholdRule = 'REAL_TIME'; // 分区域阀值规则默认值
    thresholdRuleOptions = [
        {
            key: 'entryFlow',
            val: 'NEARLY_TEN_MINUTES',
            label: `${this.$t('entryFlow')}`,
        },
        {
            key: 'existVisitors',
            val: 'REAL_TIME',
            label: `${this.$t('existVisitors')}`,
        },
    ];
    ruleForm = {
        critical: this.$props.critical,
        major: this.$props.major,
        minor: this.$props.minor,
    };
    onVirtualLevelConfigType(nv) {
        this.thresholdRule = nv;
    }
    onChangeRuleForm(val) {
        this.isValidate();
    }
    get rules() {
        return {
            critical: [
                { required: true, message: '0-99,999,999', trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                        const rep = this.repNumber;
                        if (!rep.test(value)) {
                            callback(new Error('0-99,999,999'));
                        }
                        else if (Number(value) <= Number(this.major)) {
                            callback(new Error(`${this.$t('critical')}${this.$t('notLessThan')}${this.$t('majorTip')}`));
                        }
                        else if (Number(value) <= Number(this.minor)) {
                            callback(new Error(`${this.$t('critical')}${this.$t('notLessThan')}${this.$t('minorTip')}`));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
            major: [
                { required: true, message: '0-99,999,999', trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                        const rep = this.repNumber;
                        if (!rep.test(value)) {
                            callback(new Error('0-99,999,999'));
                        }
                        else if (Number(value) >= Number(this.critical)) {
                            callback(new Error(`${this.$t('major')}${this.$t('notGreaterThan')}${this.$t('criticalTip')}`));
                        }
                        else if (Number(value) <= Number(this.minor)) {
                            callback(new Error(`${this.$t('major')}${this.$t('notLessThan')}${this.$t('minorTip')}`));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
            minor: [
                { required: true, message: '0-99,999,999', trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                        const rep = this.repNumber;
                        if (!rep.test(value)) {
                            callback(new Error('0-99,999,999'));
                        }
                        else if (Number(value) >= Number(this.major)) {
                            callback(new Error(`${this.$t('minor')}${this.$t('notGreaterThan')}${this.$t('majorTip')}`));
                        }
                        else if (Number(value) >= Number(this.critical)) {
                            callback(new Error(`${this.$t('minor')}${this.$t('notGreaterThan')}${this.$t('criticalTip')}`));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
        };
    }
    get isShowTitle() {
        return localStorage.getItem('language') === 'en-us';
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    criticalValue(val) {
        this.$emit('update:critical', val);
    }
    majorValue(val) {
        this.$emit('update:major', val);
    }
    minorValue(val) {
        this.$emit('update:minor', val);
    }
    changeRule() {
        this.$emit('update:virtualLevelConfigType', this.thresholdRule);
    }
};
__decorate([
    Prop()
], default_1.prototype, "critical", void 0);
__decorate([
    Prop()
], default_1.prototype, "major", void 0);
__decorate([
    Prop()
], default_1.prototype, "minor", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop()
], default_1.prototype, "isTotalArea", void 0);
__decorate([
    Prop()
], default_1.prototype, "virtualLevelConfigType", void 0);
__decorate([
    Watch('virtualLevelConfigType', { immediate: true })
], default_1.prototype, "onVirtualLevelConfigType", null);
__decorate([
    Watch('ruleForm', { deep: true })
], default_1.prototype, "onChangeRuleForm", null);
default_1 = __decorate([
    Component({
        name: 'ThermalIntervalValue',
        components: {},
        i18n: {
            messages: {
                zh: {
                    critical: '重度区间阈值',
                    major: '中度区间阈值',
                    minor: '轻度区间阈值',
                    level: '等级',
                    threshold: '人数阈值',
                    titleType: '热力区间值',
                    notGreaterThan: '不可大于',
                    notLessThan: '不可小于',
                    criticalTip: '重度',
                    majorTip: '中度',
                    minorTip: '轻度',
                    last10MinTraffic: '近10分钟人流',
                    entryFlow: '近10分钟进入人流',
                    existVisitors: '实时人数',
                    tipsContent: '设置单个出入口近10分钟单向人流阈值，入口统计进入人流，出口统计离开人流',
                    thresholdRule: '阈值规则',
                },
                'en-us': {
                    critical: 'Critical',
                    major: 'Major',
                    minor: 'Minor',
                    level: 'Level',
                    threshold: 'Threshold',
                    titleType: 'Thermal Interval Value',
                    notGreaterThan: ' cannot be greater than ',
                    notLessThan: ' not less than ',
                    criticalTip: 'critical',
                    majorTip: 'major',
                    minorTip: 'minor',
                    last10MinTraffic: 'Last 10min of traffic',
                    entryFlow: 'Entry Flow Last 10min',
                    existVisitors: 'Existing Visitors',
                    tipsContent: 'Set the one-way flow threshold of a single entrance and exit for nearly 10 minutes, the entrance counts the flow of people entering, and the exit counts the flow of people leaving',
                    thresholdRule: 'Threshold Rule',
                },
            },
        },
    })
], default_1);
export default default_1;
